import * as React from "react"
import { cn } from "../../utils/utils"

// Card patterns per design-system-buildmybizbrand-v1.md Section 5.
// `hoverable` should only be set on cards that are actually clickable or
// lead somewhere — a static informational card shouldn't lift on hover.
const Card = React.forwardRef(
  ({ className, variant = "standard", hoverable = false, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-radius-lg bg-surface overflow-hidden transition-all duration-200",
        variant === "elevated"
          ? "border-2 border-primary shadow-[0_8px_24px_rgba(90,124,222,0.22)]"
          : "border border-border shadow-[0_8px_24px_rgba(22,22,22,0.06)]",
        hoverable && "hover:-translate-y-1.5 hover:shadow-[0_16px_36px_rgba(22,22,22,0.10)]",
        className,
      )}
      {...props}
    />
  ),
)
Card.displayName = "Card"

// The ink-background banded header used for pricing card titles. Fixed dark
// literal (not the `ink` text-color token, which flips light/dark) since
// this band is an intentional dark accent in both themes. Relies on the
// parent Card's overflow-hidden to clip its top corners to the card's own
// radius (per the doc's nesting rule: flush corners inherit the outer
// radius automatically instead of needing their own).
const CardBandedHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("bg-[#161616] px-6 py-[22px]", className)} {...props} />
))
CardBandedHeader.displayName = "CardBandedHeader"

const CardBody = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6", className)} {...props} />
))
CardBody.displayName = "CardBody"

export { Card, CardBandedHeader, CardBody }
